export default {
    title: 'แก้ไขเวลาทำงาน',
    bureau: 'สำนักงาน',
    checkInOption: 'ตัวเลือกการลงเวลา',
    checkInByLine: 'ลงเวลาผ่าน Line',
    workday: 'เวลาทำงานประจำวัน',
    day: 'วัน',
    startTime: 'เวลาเริ่มงาน',
    checkInTime: 'เวลาเริ่มเช็คอิน',
    lateCheckInTime: 'ขาดครึ่งวัน',
    lastCheckInTime: 'ขาดเต็มวัน',
    breakHours: 'ช่วงพัก',
    endTime: 'เวลาเลิกงาน',
    totalWorkHours: 'ชั่วโมง',
    status: 'สถานะ',
    active: 'เปิด',
    inactive: 'ปิด',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    msgCannotModify: 'ไม่สามารถเปลี่ยนเเปลงตารางของวันปัจจุบันได้',
    msgRequiredField: 'กรุณากรอกข้อมูล',
    msgExceededField: 'ข้อความเกิน 255 ตัวอักษร',
    congratulation: 'ยินดีด้วย',
    msgCreateSuccess: 'กลุ่มถูกสร้างแล้ว',
    msgUpdateSuccess: 'กลุ่มถูกอัปเดตแล้ว',
    msgError: 'เกิดข้อผิดพลาด',
    days: {
        monday: 'จันทร์',
        tuesday: 'อังคาร',
        wednesday: 'พุธ',
        thursday: 'พฤหัสบดี',
        friday: 'ศุกร์',
        saturday: 'เสาร์',
        sunday: 'อาทิตย์'
    },
    workingTimeEachDay: 'เวลาการทำงานในเเต่ละวันห้ามเกิน 24 ชม.',
    limitsWorkingHours: 'จำกัดชั่วโมงการทำงานห้ามเกิน 8 ชม. ต่อวัน เเละ 48 ชม. ต่อสัปดาห์',
    maximumLimitsOvertime: 'การทำงาน OT ห้ามเกิน 36 ชม. ต่อสัปดาห์',
    information: 'คำแนะนำ',
    checkInShouldAfterEndTime: 'เวลา check in ต้องตั้งหลังจากเวลา end time ของวันก่อนหน้า',
    incorrectWorkTimePeriod: 'ช่วงเวลาทำงานไม่ถูกต้อง',
    checkInTimeOverlapStartTime: 'เวลาเช็คอินคาบเกี่ยวกับเวลาเริ่มงาน',
    startTimeOverlapCheckInTime: 'เวลาเริ่มงานคาบเกี่ยวกับเวลาเช็คอิน',
    checkInTimeOverlapEndTime: 'เวลาเช็คอินคาบเกี่ยวกับกับเวลาเลิกงาน',
    endTimeOverlapCheckInTime: 'เวลาเลิกงานคาบเกี่ยวกับเวลาเช็คอิน',
    startTimeOverlapLateCheckInTime: 'เวลาเริ่มงานคาบเกี่ยวกับเวลาขาดครึ่งวัน',
    lateCheckInTimeOverlapStartTime: 'เวลาขาดครึ่งวันคาบเกี่ยวกับเวลาเริ่มงาน',
    lateCheckInTimeOverlapLastCheckInTime: 'เวลาขาดครึ่งวันคาบเกี่ยวกับเวลาขาดเต็มวัน',
    lastCheckInTimeOverlapLateCheckInTime: 'เวลาขาดเต็มวันคาบเกี่ยวกับเวลาขาดครึ่งวัน',
    lastCheckInTimeOverlapEndTime: 'เวลาขาดเต็มวันคาบเกี่ยวกับกับเวลาเลิกงาน',
    endTimeOverlapLastCheckInTime: 'เวลาเลิกงานคาบเกี่ยวกับกับเวลาขาดเต็มวัน',
    breakhoursIsRequired: 'breakhours is required',
    specialWorkdayOverlap: 'มีวันทำงานพิเศษทับซ้อนกับตารางเข้า - ออกงาน',
    otOverlap: 'มีการทำงานล่วงเวลาทับซ้อนกับตารางเข้า - ออกงาน',
    close: 'ปิด',
    error: 'พบข้อผิดพลาด'
}
